import React from "react";
import { Link } from "react-router-dom";
import Image from "../Image/Image";
import { GlobalContext } from "../../context/GlobalContext";
import Grid from "../Grid/Grid";

const MobileMiniCard = ({ ticker, logo, company }) => {
  return (
    <div className="col-12">
      <div className="card minicard bg-light">
        <Grid>
          <div className="col-3">
            {logo && (
              <Link to={`/blog/stock/${ticker}`}>
                <Image
                  className="article-logo-mobile"
                  source={logo}
                  alternativetext="Card image cap"
                />
              </Link>
            )}
          </div>
          <div className="card-body col-9">
            <h4
              className="card-title card-title-selfmade text-truncate text-left text-light"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={company}
            >
              <Link className="text-muted" to={`/blog/stock/${ticker}`}>
                {company}
              </Link>
            </h4>
          </div>
        </Grid>
      </div>
    </div>
  );
};

const StandardMiniCard = ({ ticker, logo, company }) => {
  return (
    <div className="col-lg-3">
      <div className="card minicard bg-light">
        {logo && (
          <Link to={`/blog/stock/${ticker}`}>
            <Image
              className="article-logo"
              source={logo}
              alternativetext="Card image cap"
            />
          </Link>
        )}
        <div className="card-body">
          <h4
            className="card-title card-title-selfmade text-truncate text-center text-light"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={company}
          >
            <Link className="text-muted" to={`/blog/stock/${ticker}`}>
              {company}
            </Link>
          </h4>
        </div>
      </div>
    </div>
  );
};

function MiniCard({ ticker, logo, company }) {
  const { isMobile } = React.useContext(GlobalContext);

  if (isMobile)
    return <MobileMiniCard ticker={ticker} logo={logo} company={company} />;

  return <StandardMiniCard ticker={ticker} logo={logo} company={company} />;
}

export default MiniCard;
